import { Amount } from "@george-labs.com/design-system"

interface IAmountProps {
  value: string | number | null
  appendText?: string | null
}

const AmountComponent = (props: IAmountProps) => {
  const value = props.value ?? ""
  let appendText = ""

  if (props.value) {
    appendText = props.appendText ?? "Ft"
  }

  return (
    <>
      {value !== "" && (
        <Amount
          appendedText={appendText}
          decimalSeparator=" "
          thousandSeparator=" "
          precision={0}
          inheritFontWeight={true}
          allowNegative={false}
          value={value}
        ></Amount>
      )}
    </>
  )
}

export default AmountComponent
